import { render, staticRenderFns } from "./LoanCollateralAssetGuaranteesFieldsDisplay.vue?vue&type=template&id=0118057e&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetGuaranteesFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetGuaranteesFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetGuaranteesFieldsDisplay.vue?vue&type=style&index=0&id=0118057e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118057e",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetGuaranteesFieldsDisplay.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports